import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Products } from "./../home/products/Products";
import { Spinner } from "./../../spinner/Spinner";
import { Seo } from "../../seo/Seo";
import { Posts } from "./../home/posts/Posts";

import { serverUrl } from "./../../../utils/config";
import axios from "axios";

export const Categorie = ({
  products,
  category,
  categories,
  setCategory,
  isLoading,
  setIsLoading,
  productsFilteredCategory,
  setProductsFilteredCategory
}) => {

  const [posts, setPosts] = useState([]);
  const [categorySelected, setCategorySelected] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const { categoria } = useParams();
  const capitalizeFirstletter = (s) => {
    if (s && s.length > 0) return s.charAt(0).toUpperCase() + s.slice(1);
    return s;
  };

  useEffect(() => {
    setCategory(categoria);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFilteredPosts = () => {
    const data = new FormData();
    data.append('categoriaPost', category);
    axios.post(`${serverUrl()}/filteredPosts.php`, data)
    .then((response) => {
      if (response.data.status === "success") {
        setPosts(response.data.data);
      } else {
        console.log(response.data.message);
      }
    })
    .catch((error) => {
      console.error(error);
    });
  };

  useEffect(() => {
    if(category !== ""){
      getFilteredPosts();
    }
  }, [category]);

  useEffect(() => {
    if(categories.length > 0){
      let categoriesFiltered = categories.filter((x) => {
        return x?.categoria.toLowerCase() === category;
      });
      setCategorySelected(categoriesFiltered);
    }
  }, [categories, isLoading])

  return (
    <>
      <Seo
        title={`Adviso | ${capitalizeFirstletter(categoria?.replace(/-/g, " ").replace("maternita", "maternità"))}`}
        description={`Prodotti per ${capitalizeFirstletter(categoria?.replace(/-/g, " ").replace("maternita", "maternità"))} consigliati da acquistare su Amazon in questo momento`}
        imageUrl={`${require('./../../../assets/logo-small.png')}`}
      />
      <Spinner isLoading={isLoading} setIsLoading={setIsLoading} />
      <div className="categorie">
        <div className="container">
          <div className="titleCategory">
            <h1>{categorySelected[0]?.titolo}</h1>
            <p>{categorySelected[0]?.descrizione}</p>
          </div>
        </div>
        <Posts posts={posts} setIsLoading={setIsLoading} />
        <div className="container">
          <div className="info-affiliazione">
            <div className="icona">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path fill="#000" d="M8.492 6.9101A.5002.5002 0 0 0 7.5002 7v4.5021l.008.0899a.5.5 0 0 0 .992-.0899V7l-.008-.0899ZM8.7989 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM16 8c0-4.4183-3.5817-8-8-8S0 3.5817 0 8s3.5817 8 8 8 8-3.5817 8-8ZM1 8c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7Z" /></svg>
            </div>
            <div className="testo">
              <span>
                Questo sito partecipa al Programma di Affiliazione Amazon, 
                un'iniziativa che consente ai siti di guadagnare commissioni pubblicitarie 
                attraverso la promozione di link e prodotti di Amazon. Se decidi di acquistare 
                un prodotto tramite uno dei link presenti su questo sito 
                potremmo ricevere una commissione, senza alcun costo aggiuntivo per te. 
              </span>
              {showMore && (
                <>
                  <br />
                  <span>
                    Le opinioni espresse su questo sito sono personali e indipendenti 
                    e i link affiliazione vengono selezionati in base alla rilevanza 
                    e qualità dei prodotti, non per motivi commerciali. 
                    Amazon e il logo Amazon sono marchi registrati di Amazon.com, Inc. 
                    o delle sue consociate.
                  </span>
                </>
              )}
              <a 
                href="javascript:void(0)" 
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                {showMore ? `Leggi di meno` : `Leggi di più`}
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* {productsFilteredCategory.length > 0 ? (
        <div className="categorie">
          <div className="titleCategory">
            <div className="container">
              <h1>{capitalizeFirstletter(categoria?.replace(/-/g, " ").replace("maternita", "maternità"))}</h1>
            </div>
          </div>
          <Products products={productsFilteredCategory} />
        </div>
      ) : (
        <div className="categorie">
          <div className="titleCategoryError">
            <div className="container">
              <h1>Categoria <b>{categoria}</b> non trovata</h1>
            </div>
          </div>
          <div className="container">
            <p>Seleziona un altra categoria dal menu.</p>
          </div>
        </div>
      )} */}
    </>
  );
};